import { Typography } from 'antd';
import utils from './utils';
import { useTheme } from '../Common/ThemeContext';

const { Text } = Typography;

const MoneyDisplay = (props) => {
  const { theme } = useTheme();

  const sizes = {
    small: '11px',
    med: '22px',
    big: '30px'
  }

  let content;
  let color;

  if (Number.isNaN(props.val) || props.val === undefined){
    return <></>
  }

  // Format the number properly
  let formattedVal = utils.formatToMoney(props.val, true);

  if (props.val === 0 || props.val == null) {
    content = `- ${formattedVal}`;
    color = props.color || 'grey';
  } else {

    if (props.type === 'EXPENSE') {
      content = `- ${formattedVal}`;
      color = props.color || 'red';
    } else if (props.type === 'INCOME') {
      content = `+ ${formattedVal}`;
      color = props.color || 'green';
    } else if (props.type === 'TAX') {
      color = props.val > 0 ? 'green' : 'red';
      content = utils.formatToMoney(props.val, false);
    } else if (props.type === 'TRANSFER') {
      color = theme === 'dark' ? 'grey' : 'black';
      content = utils.formatToMoney(props.val, false);
    } else {
      // fallback if no type
      content = formattedVal;
      color = props.color || (theme === 'dark' ? 'grey' : 'black');
    }

  }

  return (
    <Text
      style={{
        color: color,
        fontSize: props.size ? sizes[props.size] : null,
        fontWeight: 1000
      }}
    >
      {content}
    </Text>
  );
};

export default MoneyDisplay;
